import React, { useContext } from 'react';
import styled from 'styled-components';
import Select from '@ubeya/shared-web/components/Select/Select';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { NO_SHOW_REASON_OPTIONS } from '@ubeya/shared-web/constants';
import { ReactComponent as BaseArrowIcon } from '@ubeya/shared-web/assets/arrow-right-small.svg';

const ArrowIcon = styled(BaseArrowIcon)`
  transform: rotate(90deg);
`;

const FixedWidthSelectWrapper = styled.div.attrs({ className: 'no-show-select-wrapper' })`
  width: 400px;
`;

const NoShowReasonSelect = ({ value, onChange, error, clearable = false }) => {
  const { t } = useContext(ConfigContext);
  const sluggedNoShowReasonsOptions = NO_SHOW_REASON_OPTIONS.map((option) => ({
    ...option,
    label: t(option.label)
  }));
  return (
    <FixedWidthSelectWrapper>
      <Select
        options={sluggedNoShowReasonsOptions}
        value={value}
        error={error}
        onChange={onChange}
        icon={ArrowIcon}
        placeholder={t('chooseReason')}
        usePortal
        clearable={clearable}
      />
    </FixedWidthSelectWrapper>
  );
};

export default NoShowReasonSelect;
